<template>
  <div class="ar-accordion" :class="['size-'+size]">
    <div
      @click="is_open = !is_open"
      class="ar-accordion-header"
    >
      <div class="ar-accordion-title">
        <slot name="title" />
      </div>
      <div class="ar-accordion-icon">
        <i class="mdi mdi-chevron-down icon" :class="[is_open ? 'open' : '']"></i>
      </div>
    </div>

    <div class="ar-accordion-body" :class="[is_open ? 'active' : '']">
      <slot name="content" />
    </div>
  </div>
</template>
<script>
export default {
  name:'Accordion',
  data : () => ({
    is_open:false,
  }),
  props:{
    size: {
      type: String,
      default: ''
    },
  },
  methods:{
  }
}
</script>